import { Icon } from "@chakra-ui/react"

const HostContactsIcon = () => {
  return (
    <Icon width='24px' height='24px' viewBox='0 0 24 24'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M22 16.92V19.92C22 20.4723 21.5523 20.92 21 20.92C10.5066 20.92 2 12.4134 2 1.92C2 1.36772 2.44772 0.920002 3 0.920002H6C6.55228 0.920002 7 1.36772 7 1.92C7 3.32559 7.25143 4.67814 7.71261 5.95251C7.88126 6.41872 7.76019 6.94073 7.40428 7.29664L5.80761 8.89332C7.53488 12.3392 10.5808 15.3851 14.0267 17.1124L15.6234 15.5157C15.9793 15.1598 16.5013 15.0387 16.9675 15.2074C18.2419 15.6686 19.5944 15.92 21 15.92C21.5523 15.92 22 16.3677 22 16.92Z'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </Icon>
  )
}

export default HostContactsIcon
